const DISPLAY_TZ = 'Australia/Sydney';

function toDate(ts: unknown): Date | null {
  if (!ts) return null;
  if (ts instanceof Date) return ts;
  if (typeof ts === 'string') return new Date(ts);
  if (typeof ts === 'object') {
    const obj = ts as Record<string, unknown>;
    if (typeof obj.toDate === 'function') return obj.toDate() as Date;
    if (typeof obj.seconds === 'number') {
      return new Date(obj.seconds * 1000 + (typeof obj.nanoseconds === 'number' ? obj.nanoseconds / 1_000_000 : 0));
    }
  }
  return null;
}

export function formatTime(ts: unknown): string {
  const d = toDate(ts);
  if (!d) return '—';
  return d.toLocaleString('en-AU', { timeZone: DISPLAY_TZ });
}

export function formatDate(ts: unknown): string {
  const d = toDate(ts);
  if (!d) return '—';
  return d.toLocaleDateString('en-AU', { timeZone: DISPLAY_TZ });
}

export function formatCurrency(amount: number, symbol: string = '$'): string {
  return `${symbol}${amount.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatCurrencyShort(amount: number, symbol: string = '$'): string {
  const abs = Math.abs(amount);
  if (abs >= 1000) {
    return `${amount < 0 ? '-' : ''}${symbol}${(abs / 1000).toFixed(1)}k`;
  }
  return formatCurrency(amount, symbol);
}

export function roundTo50Cents(n: number): number {
  return Math.round(n * 2) / 2;
}

export function classNames(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}
